module.exports = __webpack_public_path__ + "img/customer_inactive.752f6951.svg";